/**
 * AgeRangeFilter Component
 *
 * "Age range" filter section with pill button options.
 * Options: 2-3, 3-4, 4-5 (years). Multiple can be selected.
 */

import { useFilter, AgeRangeOption } from '../../../contexts/FilterContext';
import FilterSection from './FilterSection';
import FilterPillButton from './FilterPillButton';

const AGE_RANGE_OPTIONS: AgeRangeOption[] = ['2 - 3', '3 - 4', '4 - 5'];

export default function AgeRangeFilter() {
  const { filters, toggleAgeRange } = useFilter();

  return (
    <FilterSection title="Age range">
      <div className="flex flex-wrap gap-2">
        {AGE_RANGE_OPTIONS.map((option) => (
          <FilterPillButton
            key={option}
            label={option}
            isSelected={filters.ageRanges.includes(option)}
            onClick={() => toggleAgeRange(option)}
          />
        ))}
      </div>
    </FilterSection>
  );
}
